/** Scroll the app's main container (#root), not window — see index.css. */
export function scrollAppToTop(behavior = "auto") {
  const root = document.getElementById("root");
  if (root) {
    root.scrollTo({ top: 0, left: 0, behavior });
    root.scrollTop = 0;
  }
  window.scrollTo({ top: 0, left: 0, behavior });
}
